export enum ViewMode {
  Desktop,
  Mobile
}
